export const SET_DATA_LOADED = "SET_DATA_LOADED";

export const setDataLoaded = (dataLoaded: boolean) => {
  return {
    dataLoaded,
    type: SET_DATA_LOADED
  };
};
